var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPins({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8332 8.00006C29.9999 7.50006 28.9999 7.83339 28.6666 8.66673C28.1666 9.50006 28.4999 10.5001 29.3332 10.8334C31.8332 12.1667 33.4999 14.5001 33.4999 17.1667C33.4999 23.3334 27.8332 31.8334 25.1666 35.5001C24.8332 35.0001 24.4999 34.5001 23.9999 34.0001C23.4999 33.1667 22.4999 33.0001 21.6666 33.6667C20.8332 34.1667 20.6666 35.1667 21.3332 36.0001C22.8332 38.0001 23.8332 39.3334 23.8332 39.5001C24.1666 39.8334 24.6666 40.1667 25.1666 40.1667C25.6666 40.1667 26.1666 40.0001 26.4999 39.5001C26.6666 38.8334 36.6666 26.5001 36.6666 17.3334C36.6666 13.5001 34.3332 10.0001 30.8332 8.00006Z",
    fill: "#006AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1668 28.5001C38.3335 28.0001 37.3335 28.3334 36.8335 29.1667C34.1668 33.6667 31.3335 37.1667 31.3335 37.3334C30.8335 38.0001 30.8335 39.1667 31.5001 39.6667C31.8335 40.0001 32.1668 40.0001 32.5001 40.0001C33.0001 40.0001 33.5001 39.8334 33.8335 39.3334C34.0001 39.1667 36.8335 35.5001 39.6668 30.8334C40.1668 30.0001 40.0001 29.0001 39.1668 28.5001Z",
    fill: "#006AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 6.66675C9.6665 6.66675 6.6665 9.66675 6.6665 13.3334C6.6665 17.0001 9.6665 20.0001 13.3332 20.0001C16.9998 20.0001 19.9998 17.0001 19.9998 13.3334C19.9998 9.66675 16.9998 6.66675 13.3332 6.66675ZM13.3332 16.6667C11.4998 16.6667 9.99984 15.1667 9.99984 13.3334C9.99984 11.5001 11.4998 10.0001 13.3332 10.0001C15.1665 10.0001 16.6665 11.5001 16.6665 13.3334C16.6665 15.1667 15.1665 16.6667 13.3332 16.6667Z",
    fill: "#006AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0C6 0 0 5.66667 0 12.6667C0 23.8333 11.5 38.6667 12 39.3333C12.3333 39.8333 12.8333 40 13.3333 40C13.8333 40 14.3333 39.8333 14.6667 39.3333C15.1667 38.6667 26.6667 23.8333 26.6667 12.6667C26.6667 5.66667 20.6667 0 13.3333 0ZM13.3333 35.5C10.3333 31.3333 3.33333 20.5 3.33333 12.6667C3.33333 7.5 7.83333 3.33333 13.3333 3.33333C18.8333 3.33333 23.3333 7.5 23.3333 12.6667C23.3333 20.5 16.3333 31.3333 13.3333 35.5Z",
    fill: "#006AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPins);
export default __webpack_public_path__ + "static/media/pins.3ecbbd0d38b3f984559c531885b64ef3.svg";
export { ForwardRef as ReactComponent };